// @flow
import { connect } from 'react-redux';
import {
  newOfferOptionsMappedByCreditableServiceSelector,
  secondaryCharacteristicsOptionsSelector,
} from '../../../../../modules/NewOffer/selectors';
import type { StateProps } from './PlanDetails';
import { PlanDetails } from './PlanDetails';

const mapStateToProps = (state): StateProps => ({
  options: newOfferOptionsMappedByCreditableServiceSelector(state),
  secondaryCharacteristicsOptions: secondaryCharacteristicsOptionsSelector(state),
});

export default connect(mapStateToProps)(PlanDetails);
